import React from 'react'
import { useEffect } from 'react';
import { useScroll } from '../ScrollContext';
import { useNavigate } from "react-router-dom";
import '../../src/selfcss/team.css'
import Team from '../components/Team';
import Services from '../components/Services';
import Destination from './Destination';
import About from './About';
import Packages from './Packages';
import Process from './Process';
import WhatsAppFloatButton from '../components/WhatsAppFloatButton';

export default function Home() {

  const { scrollTarget, setScrollTarget } = useScroll();
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    if (scrollTarget) {
      const section = document.getElementById(scrollTarget);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
        setScrollTarget(null); // clear after scroll
      }
    }
  }, [scrollTarget, setScrollTarget]);

  const handleBookNow = () => {
    navigate("/booknow"); // Redirect to the /booknow page
  };

  return (
    <div>
      <div className="container-fluid bg-primary py-5 mb-5 hero-header" id="home">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white mb-3 animated slideInDown">
                Explore the World with Kothari Tour and Travels
              </h1>
              <p className="fs-4 text-white mb-4 animated slideInDown">
                Discover amazing destinations, luxurious rides, and unforgettable experiences with us.
              </p>
              <button
                className="btn btn-light rounded-pill py-3 px-5 animated slideInDown"
                onClick={handleBookNow}
              >
                Book Your Next Taxi
              </button>
            </div>
          </div>
        </div>
      </div>

    {/* About Start */}
       <About />
    {/* About End */}

    {/* Service Start */}
      <Services />
    {/* Service End */}

    {/* Package Start */}
    <Packages />
    {/* Package End */}

    {/* Destination Start */}
        <Destination />
    {/* Destination End */}

    {/* Process Start */}
       <Process />
    {/* Process Start */}

    <WhatsAppFloatButton phoneNumber="919610415221" />

    
    {/* Team Start */}
    <div className="container-xxl py-5" id="team">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Travel Guide
          </h6>
          <h1 className="mb-5">Meet Our Guide</h1>
        </div>
        <Team />
      </div>
    </div>
    {/* Team End */}


    {/* Testimonial Start */}
    {/* <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s" id="testimonial">
      <div className="container">
        <div className="text-center">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Testimonial
          </h6>
          <h1 className="mb-5">Our Clients Say!!!</h1>
        </div>
        <div className="owl-carousel testimonial-carousel position-relative">
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-1.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">John Doe</h5>
            <p>New York, USA</p>
            <p className="mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-2.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">John Doe</h5>
            <p>New York, USA</p>
            <p className="mt-2 mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-3.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">John Doe</h5>
            <p>New York, USA</p>
            <p className="mt-2 mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-4.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">John Doe</h5>
            <p>New York, USA</p>
            <p className="mt-2 mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
        </div>
      </div>
    </div> */}
    {/* Testimonial End */}  
    </div>
  )
}
